import { Dispatch } from 'react';

import { v4 as generateUUIDV4 } from 'uuid';

import { getSearchDData } from 'utility/Extract/getSearchDData';

import {
    AccommodationListAction,
    AccommodationListReducerAction,
    ActionMap,
    StartNewSearchScope,
} from './types';

export const buildActionMap = (
    dispatch: Dispatch<AccommodationListReducerAction>
): ActionMap => ({
    startNewSearch(searchUrl, scope = StartNewSearchScope.Initial) {
        const searchDData = getSearchDData();
        if (!searchDData?.clientId.length) {
            throw new Error('missing clientId from searchD data');
        }
        dispatch({
            type: AccommodationListAction.StartNewSearch,
            payload: {
                searchUrl,
                scope,
                transactionId: generateUUIDV4(),
                clientId: searchDData.clientId,
            },
        });
    },
    onPollError(updatePending: boolean) {
        dispatch({
            type: AccommodationListAction.PollError,
            payload: updatePending,
        });
    },
    onPollTimeout(updatePending: boolean) {
        dispatch({
            type: AccommodationListAction.PollTimeout,
            payload: updatePending,
        });
    },
    onPollUpdate() {
        dispatch({ type: AccommodationListAction.PollUpdate });
    },
    onPollFinished() {
        dispatch({ type: AccommodationListAction.PollFinished });
    },
    updateAccommodationList(response) {
        dispatch({
            type: AccommodationListAction.UpdateAccommodationList,
            payload: response,
        });
    },
    updateLastClickedHotel(id, name, isFeaturedHotel) {
        dispatch({
            type: AccommodationListAction.UpdateLastClickedHotel,
            payload: {
                id,
                name,
                isFeaturedHotel,
            },
        });
    },
});
